import AbstractListView from '@UI/Store/AbstractListView';
import type AiCostLimitUserView from '@UI/Store/AiCostLimits/Views/AiCostLimitUserView';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class AiCostLimitUsersListView extends AbstractListView<AiCostLimitUserView> {
	readonly accountId: number;

	constructor(accountId: number, list: readonly AiCostLimitUserView[]) {
		super(list, 'AiCostLimitUsersListView');

		this.accountId = accountId;

		Object.freeze(this);
	}
}

export default AiCostLimitUsersListView;
